// Small form adapters shared by template previews and normal medicine editors.
// They never publish or modify product details outside the selected text fields.
export const TEMPLATE_FIELDS = {
  metaKeyword: 'Meta keywords', pageTitle: 'Page title', metaTitle: 'Meta title', metaDesc: 'Meta description',
  'section:FAQ': 'FAQ', 'section:Indication & Dosage': 'Indication & Dosage',
};
export const TEMPLATE_COPY_FIELDS = Object.keys(TEMPLATE_FIELDS).filter(key => key !== 'section:Indication & Dosage');
export const templateFieldValue = (form, key) => key.startsWith('section:')
  ? (form?.additionalSectionList || form?.additionalSections || []).find(section => section.sectionName === key.slice(8))?.content || ''
  : form?.[key] || '';
export const templateVersionId = version => typeof version === 'string' ? version : version?.id || version?._id || '';
export function applyTemplateFields({ fields, selected = TEMPLATE_COPY_FIELDS, current, baseline, setters, automatic = false, previous = {} }) {
  const applied = [], skipped = [];
  let sections = [...(current.additionalSectionList || current.additionalSections || [])], changed = false;
  for (const key of selected) {
    if (!Object.prototype.hasOwnProperty.call(TEMPLATE_FIELDS, key) || typeof fields?.[key] !== 'string') continue;
    const value = templateFieldValue(current, key), expected = templateFieldValue(baseline || current, key);
    const untouched = value === expected;
    const generated = Object.prototype.hasOwnProperty.call(previous, key) ? value === previous[key] : !value;
    if (!untouched || (automatic && !generated)) { skipped.push(key); continue; }
    if (key.startsWith('section:')) {
      const name = key.slice(8), index = sections.findIndex(section => section.sectionName === name);
      if (index < 0) sections.push({ sectionName: name, content: fields[key] });
      else sections[index] = { ...sections[index], content: fields[key] };
      changed = true;
    } else if (setters[key]) setters[key](fields[key]);
    else { skipped.push(key); continue; }
    applied.push(key);
  }
  if (changed) setters.additionalSectionList?.(sections);
  return { applied, skipped };
}

export function templateFormContent({ generic, brand, current = {}, details = {} }) {
  return {
    ...details, generic: generic || '', genericBrand: brand || '',
    metaKeyword: current.metaKeyword || '', pageTitle: current.pageTitle || '', metaTitle: current.metaTitle || '', metaDesc: current.metaDesc || '',
    additionalSections: (current.additionalSectionList || current.additionalSections || []).map(({ sectionName, content }) => ({ sectionName, content: content || '' })),
  };
}

export function analyticsReportTotals(report) {
  if (!report) return null;
  if (report.totals) return report.totals;
  const rows = report.rows || [], clicks = rows.reduce((sum, row) => sum + (Number(row.clicks) || 0), 0), impressions = rows.reduce((sum, row) => sum + (Number(row.impressions) || 0), 0);
  const positioned = rows.filter(row => typeof row.position === 'number' && row.impressions > 0), weight = positioned.reduce((sum, row) => sum + row.impressions, 0);
  return { clicks, impressions, ctr: impressions ? clicks / impressions : null, position: weight ? positioned.reduce((sum, row) => sum + row.position * row.impressions, 0) / weight : null };
}
